/*   
  In cases where we dont want data to be undefined while we reload data with Apollo we use this function. That is for example 
  the case when using fetchMore

  So if: 
  - Query loads for the first time. newData and prevData are undefined -> Returns undefined
  - Query has finished loading and value is available in cache -> Returns newData
  - Query in currently loading and data form the previous succesfull query is existing -> Returns prevData
  */
const getLatestDefinedData = <T>(newData: T | undefined, prevData: T | undefined): T | undefined => {
  if (newData !== undefined) {
    return newData;
  } else if (prevData !== undefined) {
    return prevData;
  }
  return undefined;
};

export default getLatestDefinedData;
